// extracted by mini-css-extract-plugin
module.exports = {"balanceContent":"ProductNutrientPanel_balanceContent__YGrAd","text__l":"ProductNutrientPanel_text__l__pcpNB"};